import toggleVisibility from '../toggleVisibility';

// A discount under 0.5% rounds to zero, so the badge hides on the rounded
// figure rather than a raw price comparison, matching the server-rendered badge.
const updateSaleBadge = ({ badgeEl, percentageEl, price, compareAtPrice }) => {
  if (!badgeEl) return;

  const isOnSale = compareAtPrice > price;
  const salePercentage = isOnSale ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100) : 0;

  toggleVisibility(badgeEl, salePercentage > 0);
  const template = badgeEl.dataset.saleBadgeTemplate;
  if (salePercentage <= 0 || !percentageEl || !template) return;

  percentageEl.textContent = template.replace('__PERCENTAGE__', salePercentage);
};

export default updateSaleBadge;
